export default "__VITE_ASSET__D1wpbzK6__"